// removed by extract-text-webpack-plugin
module.exports = {"root":"_2hmNy4j"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/components/RefineBar/components/WorkTypes/WorkTypes.less
 ** module id = 915
 ** module chunks = 0
 **/